import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Filter = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.564 5.168c-1.295-1.53-.22-3.898 1.8-3.898h39.267c2.02 0 3.09 2.362 1.82 3.89l-.007.01L28.85 22.32l-.014.016a.298.298 0 0 0-.068.205v18.664a2.369 2.369 0 0 1-2.365 2.364h-8.797a2.369 2.369 0 0 1-2.364-2.364V22.54a.367.367 0 0 0-.087-.227L.564 5.168Zm1.547-1.31L16.71 21.014c.344.412.56.95.56 1.527v18.664c0 .183.154.337.337.337h8.797a.342.342 0 0 0 .338-.337V22.54c0-.547.183-1.1.572-1.542L41.895 3.862a.349.349 0 0 0-.264-.565H2.364a.341.341 0 0 0-.253.561Z"
  }));
});
Filter.displayName = 'Filter';
Filter.defaultProps = {
  'aria-label': 'Filter'
};
export default Filter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Filter.js
// module id = 3162
// module chunks = 11